import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { Grid, Typography } from "@material-ui/core";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import Service from "./RegionService";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from "../../componentes/chip/DefaultChip";

const columnsCountry = (t) => [
    {
        field: "idCountry",
        visible: false
    },
    {
        field: "nmCountry",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="country" name="country" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.nmCountry}
                        </Typography>}
                    />
                </>
            )
        }

    },
    {
        field: "initials",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="initials" />;
        }, flex: 0.5
    },
    {
        field: "ddi",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="ddi" />;
        }, flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.ddi}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        width: 150,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export default function RegionCountry() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    function reducer(state, action) {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case 'clear':
                return initialCountryRegistrationState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return state
        }
    }

    const initialCountryRegistrationState = {
        idCountry: 0,
        nmCountry: "",
        initials: "",
        ddi: "",
        status: 1,
        countryRows: [],
        idUser: userId,
        alertMessage: "",
        success: false,
        error: false
    };

    const [country, dispatch] = useReducer(reducer, initialCountryRegistrationState)
    const { idCountry, nmCountry, initials, ddi, status, success, alertMessage, error, countryRows } = country

    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    }

    const handleChangeStatus = ({ target }) => {
        dispatch({
            type: 'update',
            data: { status: target.value }
        })
    }


    const canSave = () => nmCountry;

    const selectedCountryChanged = (data) => {
        dispatch({
            type: 'update',
            data: { idCountry: idCountry, ...data, }
        })

    };

    const handleSearchRegionCountry = () => {
        const { countryRows, alertMessage, success, error, ...data } = country
        Service
            .getCountry(data)
            .then((response) => {
                dispatch({
                    type: 'update',
                    data: { countryRows: response.data }
                })
            })
            .catch((e) => { });
    };

    const handleClearRegionCountry = () => {
        dispatch({ type: 'clear' })
    };

    const saveRegionCountry = () => {
        if (canSave()) {
            const { countryRows, alertMessage, success, error, ...data } = country
            if (idCountry === 0) {
                Service
                    .createCountry(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idCountry > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionCountry();
                        }
                    })
                    .catch((e) => { });
            } else {
                Service
                    .updateCountry(data)
                    .then((response) => {
                        if (response.status === 200 && response.data.idCountry > 0) {
                            dispatch({
                                type: 'success',
                                data: { alertMessage: t("success"), error: false, success: true }
                            })
                            handleSearchRegionCountry();
                        }
                    })
                    .catch((e) => { });
            }
        }
        else {
            dispatch({
                type: 'update',
                data: { alertMessage: t("checkFields"), error: true, success: false }
            })
        }
    };

    return (

        <DefaultScreenAccordion
            title={t("country")}
            isRegister
            fields={
                <>
                    <GridItemContainer>
                        <CustomAlert
                            message={alertMessage}
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <GridInputRow>
                            <Grid item md={3}>
                                <InputField
                                    iconLabelSwitch={<IconLabelSwitch fontSize="small" name="country" labelName="nmCountry" />}
                                    name="nmCountry"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={nmCountry}
                                    error={error && nmCountry === ""}
                                    translationString={"nmCountry"}
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    name="initials"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={initials}
                                    length={50}
                                    error={error && initials === ""}
                                    translationString={"initials"}
                                />
                            </Grid>
                            <Grid item md={3}>
                                <InputField
                                    name="ddi"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={ddi}
                                    length={50}
                                    error={error && ddi === ""}
                                    translationString={"ddi"}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <DefaultAutocomplete
                                    name={"status"}
                                    onChange={handleChangeStatus}
                                    value={status}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        { id: 1, name: t("active"), status: 1 },
                                        { id: 2, name: t("all"), status: 1 },
                                    ]}
                                    error={error && status === 2}
                                    placeholder={t("status")}
                                />
                            </Grid>
                        </GridInputRow>
                        <SearchClearSaveRow
                            onClickSearch={handleSearchRegionCountry}
                            onClickSave={saveRegionCountry}
                            onClickClear={handleClearRegionCountry}
                        />
                    </GridItemContainer>

                    {countryRows.length > 0 ? (
                        <DefaultDatagrid
                            dataSource={countryRows}
                            columns={columnsCountry(t)}
                            allowPaging={true}
                            cellSelected={(selected) => {
                                selectedCountryChanged(selected.data);
                            }}
                        />
                    ) : null}
                </>
            } />
    );
};